// Dependencies
import styled from 'styled-components';

const LocationPromptStyles = styled.div`
  .modal-header .heading {
    align-items: center;
    display: flex;
    margin: 0 auto;

    .icon {
      margin: 0 0 0 0.6rem;
      width: 1.5rem;
    }
  }

  .modal-body {
    text-align: center;
  }

  .map {
    display: flex;
    width: 100%;
    max-width: 80%;
    margin: 0 auto 2rem auto;
  }

  @media (min-width: 768px) {
    .map {
      max-width: 60%;
    }
  }

  @media (min-width: 1200px) {
    .map {
      max-width: 70%;
    }
  }
`;

export default LocationPromptStyles;
